// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"445":"4e565f9b27564fcce34e","824":"08cf6bf0641c5c847fe8"}[chunkId] + ".chunk.js";
};